import React from "react"
import Image from "./image"

const BlueImage = ({ filename, alt }) => <Image filename={filename} alt={alt} className="image-filter blue-filter"/>
export default BlueImage

